import { AirCfarSchedulePriceQuoteRequest } from "@b2bportal/air-cfar-api";
import { Product, ProductOpaqueValue } from "@b2bportal/purchase-api";
import { ParentState } from "@checkout/types";
import {
  CartContext,
  FlightContext,
  FlightPassengerInformationContext,
} from "@checkout/index";
import { CommonParentContext } from "@checkout/states/common";
import { CancelForAnyReasonContext } from "./context";

export interface AirCfarProduct extends ProductOpaqueValue {
  type: typeof Product.AirCfar;
  value: AirCfarSchedulePriceQuoteRequest;
}

export enum CancelForAnyReasonState {
  route = "route",
  initialize = "initialize",
  addProduct = "addProduct",
  error = "error",
}

export interface PartialParentContextWithAirCfar
  extends CartContext,
    CommonParentContext,
    FlightContext {
  [ParentState.passengerInformation]: FlightPassengerInformationContext;
  [ParentState.cancelForAnyReason]: CancelForAnyReasonContext;
}
